angular.module('acme.view.application.importExport.importExportJob.directives.importExportJobMapping', [
  'acme.common.service.utils'
])
.directive('importExportJobMapping', importExportJobMapping)
.controller('ImportExportJobMappingController', ImportExportJobMappingController);

function importExportJobMapping() {
  return {
    restrict: 'A',
    replace: true,
    controller: 'ImportExportJobMappingController',
    controllerAs: '$ctrl',
    scope: {},
    templateUrl: 'views/application/views/importExport/importExportJob/directives/importExportJobMapping/importExportJobMapping.tpl.html',
    bindToController: {
      mapping: '=?',
      isEditMode: '=?editMode',
      jobType: '=',
      types: '<?',
      isNew: '<?',
      cancel: '&?',
      save: '&'
    }
  };
}

/**
 * Controller responsible for TODO Add responsibilities
 * @class ImportExportJobMappingController
 * @constructor
 * @param $timeout
 * @param {Object} UtilsService - utilities function helpers
 * @param JOB_TYPE - ImpEx Job types
 * @return {ImportExportJobMappingController} - Class instance
 */
function ImportExportJobMappingController($timeout, UtilsService, JOB_TYPE) {
  Object.assign(this, {
    $timeout: $timeout,
    UtilsService: UtilsService,
    JOB_TYPE: JOB_TYPE
  });

  if (this.isNew) {
    this.mapping = {};
  }
}

/**
 * Angular lifecycle method $onInit
 * Ran when bindings are ready
 * @public
 * @memberOf ImportExportJobMappingController
 * @return {Undefined} -
 */
ImportExportJobMappingController.prototype.$onInit = function () {
  this.vm = this._getVm(this);
};

/**
 * @typedef $changesObj
 * @type {Object}
 * @property {*} currentValue - The actual value
 * @property {*} previousValue - The previous value
 */

/**
 * Angular lifecycle method $onChanges
 * Ran when watched bindings change
 * @public
 * @memberOf ImportExportJobMappingController
 * @param {Object.<String, $changesObj>} changes - Angular changesObj
 * @return {Undefined} -
 */
ImportExportJobMappingController.prototype.$onChanges = function (changes) {
  var update = this.UtilsService.removeUndefinedProperties(changes, true);
  Object.assign(this, update);
  this.vm = this._getVm(this);
};

/**
 * Computes the viewModel and return it
 * @memberOf ImportExportJobMappingController
 * @private
 * @param {Object=} initialData - initial data used as a basis for the model
 *                                Returns default values if no data is passed
 * @return {ImportExportJobMappingController.viewModel} - The viewModel
 */
ImportExportJobMappingController.prototype._getVm = function (initialData) {
  var _data = initialData || {},
    seed = Math.random().toString().slice(2,11),
    types = initialData.types || [],
    mapping = initialData.mapping || {},
    isSaving = initialData.isSaving || false,
    message = initialData.message || '',
    isNew = angular.isDefined(initialData.isNew) ? initialData.isNew : false,
    isEditMode = angular.isDefined(initialData.isEditMode) ? initialData.isEditMode : false,
    mappingDetailsView = {
      columns: 1,
      columnWidth: 12,
      sorting: false,
      data: '$ctrl.vm.mapping',
      showEmpty: true,
      include: [
        'tableType',
        'fieldFrom',
        'fieldTo',
        'fieldExpression',
        'sequence'
      ]
    };

  return {
    isEditMode: isEditMode,
    isNew: isNew,
    isSaving: isSaving,
    message: message,
    mapping: mapping,
    mappingDetailsView: mappingDetailsView,
    seed: seed,
    types: types
  };
};

ImportExportJobMappingController.$inject = [
  '$timeout',
  'UtilsService',
  'JOB_TYPE'
];
